<template>
   <div class="main-content">
      <div class="show-sidebar-btn" @click="toggleSidebarVisibility()">
         <img src="../assets/icons/menu.svg">
      </div>
      <side-bar
         :language-is-english="languageIsEnglish"
         :show-sidebar="showSidebar"
      />
      <map-div
         :language-is-english="languageIsEnglish"
         :choropleth-label="hoveredInfoDescription"
         v-on:show-print-modal="$emit('show-print-modal')"
      />
   </div>
</template>

<script>
import MapDiv from '../components/MapDiv';
import SideBar from '../components/SideBar';

// import { updateAdminLayerLanguage } from '../js/layers/admin';
import { getNavigator, initNavigator } from '../js/mapNavigator/index';
import { initMap, getMap, nepalBounds, animateToExtent } from '../js/mapHelpers';
import { getDataFromCache } from '../js/api';
import { bus } from '../main';

// const capitalize = text => text.slice(0,1).toUpperCase() + text.slice(1).toLowerCase();

export default {
   components: {
      'map-div': MapDiv,
      'side-bar': SideBar,
   },
   props: {
      languageIsEnglish: {type: Boolean, required: true},
   },   
   data() {
      return {
         showSidebar: true,
         hoveredInfoDescription: '',
      }
   },
   mounted()
   {
      // initialize map
      let map = getMap('check');
      (map) ? map.setTarget('map') : ( map = initMap({target: 'map'}) );
      animateToExtent(nepalBounds);

      // initialize navigator
      let navigator = getNavigator();
      (!navigator) ?
         (navigator = initNavigator(map))
         :
         setTimeout(() => navigator.selectState(0), 250);
      
      // listen to change hovered info event
      bus.$on('change-hovered-info', () =>
      {
         if (navigator.hoveredInfo)
         {
            const {division, label, labelNepali, code,} = navigator.hoveredInfo;
            const data = getDataFromCache(division, null, code);
            const value = !data ? "Not found" :
               this.languageIsEnglish ? data.value :
               data.valueNepali;
            this.hoveredInfoDescription = `${this.languageIsEnglish ? label : labelNepali}: ${value}`;
         }
         else
         {
            this.hoveredInfoDescription = '';
         }
      });
      bus.$emit('init-map', map);
      bus.$emit('navigator-initialized', navigator);
      bus.$on('language-changed', language =>
      {
         // updateAdminLayerLanguage(language);
         navigator.setLabelLanguage(language);
      });
   },
   beforeDestroy()
   {
      getMap().setTarget(null);
   },
   methods: {
      toggleSidebarVisibility()
      {
         this.showSidebar = !this.showSidebar;
         window.setTimeout(() => getMap().updateSize(), 600);
      },
   }
}
</script>

<style lang="scss" scoped>
.main-content {
   display: flex;
   height: 100%;
   // align-items: center;
   justify-content: space-evenly;
   position: relative;
}

.main-content div {
   transition: 0.5s ease;
}

.show-sidebar-btn {
   position: absolute;
   top: -3em;
   left: 0.4em;
   z-index: 5;
   overflow: hidden;
   display: flex;
   align-items: center;
   justify-content: center;
   height: 2.4em;
   width: 2.4em;
   opacity: 0.9;
   border-radius: 50%;
   cursor: pointer;
   z-index: 5;

   &:hover {
      background: rgba(255,255,255,0.2);
   }
}
</style>
